import React, { useState } from "react";
import { Link } from "react-router-dom";
import Accordion from 'react-bootstrap/Accordion';
import RadioBox from './RadioBox';
import RadioBoxCondition from './radioBoxCondition';
import RadioboxRating from './radioboxRating';
import Checkbox1 from "./Checkbox1";
import CustomerPriceRange from "./CustomerPriceRange";
import LocationFilterBar from "./LocationFilterBar";
import { resolveBuyerLocation, saveTempBuyerLocation } from "../../utils/buyerLocation";
import { MdClose, MdFilterList, MdRefresh } from "react-icons/md";
import { FaTags, FaStar, FaBoxOpen, FaThList } from "react-icons/fa";
import './Filters.css';
import { elakayAutoText } from "./dataElakay";


const Filters = props => {
    const [checked, setCheked] = useState([]);
    const [useC, setUseC] = useState(false);
    const [newC, setNewC] = useState(false);
    const [stars1, setStars1] = useState(false);
    const [stars2, setStars2] = useState(false);
    const [stars3, setStars3] = useState(false);
    const [stars4, setStars4] = useState(false);
    const [stars5, setStars5] = useState(false);

    // Local Selling (mission 2.8): "Use my default address"/"Change
    // location" now lives here instead of the top banner (ProductGridPage.jsx
    // keeps only the read-only "Products available near X" label). Same
    // priority-chain formula as ProductGridPage.jsx -- reused, not
    // reimplemented -- and saveTempBuyerLocation() (called by
    // LocationFilterBar's onChange below) dispatches BUYER_LOCATION_EVENT so
    // ProductGridPage.jsx's own buyerLocation state (which actually drives
    // the product query) stays in sync without prop-drilling through
    // Layout/Sidebar/SideDrawer1.
    const defaultAddress = Array.isArray(props.infoSource?.userInfo?.address)
        ? (props.infoSource.userInfo.address.find((a) => a?.addressDefault) || props.infoSource.userInfo.address[0])
        : null;
    // Shows the saved Target Location only; without one the bar shows the
    // destination the server resolved (address or approximate IP).
    const [buyerLocation, setBuyerLocation] = useState(() => resolveBuyerLocation());

    const allStars = {
        stars1, setStars1,
        stars2, setStars2,
        stars3, setStars3,
        stars4, setStars4,
        stars5, setStars5,
    };

    const { 
        infoSource, 
        gridButon,
         SliderPunShow =true,
        handleFilters,
        prices,
        click,
        setMyFilters,
        AllCategorie = null
    } = props;

    const {
        filters = [],
        items = [],
        cartegory = null
    } = AllCategorie? AllCategorie : infoSource?.categories;

    const clickButton = () => {
        setUseC(false);
        setNewC(false);
        setStars1(false);
        setStars2(false);
        setStars3(false);
        setStars4(false);
        setStars5(false);
        setMyFilters({ filters: [] });
        setCheked([]);
        
        var inputs = document.querySelectorAll('.check2');
        for (var i = 0; i < inputs?.length; i++) {
            inputs[i].checked = false;
        }
        setMyFilters({ filters: {} });
    };
    const F1 =  JSON.parse(SliderPunShow)
    
    const FilterProduct = () => (
        <div className="SideDrawer1-filters-container-modern">
            {/* Header avec gradient */}
            <div className="SideDrawer1-filters-header">
                <div className="SideDrawer1-filters-header-content">
                    <div className="SideDrawer1-filters-icon-wrapper">
                        <MdFilterList className="SideDrawer1-filters-icon" />
                    </div>
                    <div>
                        <span className="SideDrawer1-filters-eyebrow">ELAKAY</span>
                        <h3 className="SideDrawer1-filters-title">
                            {infoSource.laguangeElakay('title', infoSource.languageAPI).filters}
                        </h3>
                    </div>
                </div>
                <button type="button" className="SideDrawer1-filters-close-btn" onClick={click} aria-label={elakayAutoText("h_c2db1e0ed9c89b", "Close filters")}>
                    <MdClose />
                </button>
            </div>
        {gridButon()}
            <LocationFilterBar
                infoSource={infoSource}
                location={buyerLocation}
                onChange={setBuyerLocation}
                hasDefaultAddress={!!defaultAddress}
                onUseDefaultAddress={() => {
                    // Dropping the Target Location lets the server use the
                    // default address again (Location Context priority).
                    saveTempBuyerLocation(null);
                    setBuyerLocation(null);
                }}
            />
            {/* Body avec scroll */}
            <div className="SideDrawer1-filters-body">
                <Accordion className="SideDrawer1-filters-accordion">
                    {/* Catégories */}
                    {F1 && (
                        <Accordion.Item eventKey="184" className="SideDrawer1-filter-item">
                            <Accordion.Header className="SideDrawer1-filter-header">
                                <FaThList className="SideDrawer1-filter-header-icon" />
                                <span className="SideDrawer1-filter-header-text">
                                    {infoSource.laguangeElakay('title', infoSource.languageAPI).categoriesPage}
                                </span>
                            </Accordion.Header>
                            <Accordion.Body className="SideDrawer1-filter-body">
                                <div className="SideDrawer1-categories-list">
                                    {items && items?.map((c, i) => (
                                        <Link
                                            key={i}
                                            to={`/product/${c.supCategoryID._id && (c.supCategoryID.publicId || c.supCategoryID._id)}`}
                                            state={cartegory?._id ? {
                                                previousCategory: {
                                                    id: cartegory.publicId || cartegory._id,
                                                    title: infoSource.getCategoryNames(cartegory)?.name?.[0]
                                                }
                                            } : undefined}
                                            className="SideDrawer1-category-link"
                                        >
                                            <div className="SideDrawer1-category-item">
                                                <span className="SideDrawer1-category-dot"></span>
                                                <span className="SideDrawer1-category-name">
                                                    {infoSource.getCategoryNames(c).name[0]}
                                                </span>
                                            </div>
                                        </Link>
                                    ))}
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                    )}
                    
                    {/* Prix */}
                    {prices && (
                        <Accordion.Item eventKey="284" className="SideDrawer1-filter-item">
                            <Accordion.Header className="SideDrawer1-filter-header">
                                <FaTags className="SideDrawer1-filter-header-icon" />
                                <span className="SideDrawer1-filter-header-text">
                                    {infoSource.laguangeElakay('title', infoSource.languageAPI).filterPrice}
                                </span>
                            </Accordion.Header>
                            <Accordion.Body
                             className="SideDrawer1-filter-body"
                             >
                                <div className="SideDrawer1-price-stack">
                                    <RadioBox
                                        infoSource={infoSource}
                                        prices={prices}
                                        handleFilters={filtersC =>
                                            handleFilters(filtersC, "price")
                                        }
                                    />
                                    <CustomerPriceRange
                                        handleFilters={filtersC =>
                                            handleFilters(filtersC, "price")
                                        }
                                    />
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                    )}

                    {/* Checkbox Filters */}
                    {!F1 && (
                        <Checkbox1
                            infoSource={infoSource}
                            filters={filters}
                            checked={checked} 
                            setCheked={setCheked}
                            handleFilters={(filtersC, color) =>
                                handleFilters(filtersC, color)
                            }
                        />
                    )}
                    
                    {/* Condition */}
                    {handleFilters && (
                        <>
                            <Accordion.Item eventKey="384" className="SideDrawer1-filter-item">
                                <Accordion.Header className="SideDrawer1-filter-header">
                                    <FaBoxOpen className="SideDrawer1-filter-header-icon" />
                                    <span className="SideDrawer1-filter-header-text">
                                        {infoSource.laguangeElakay('title', infoSource.languageAPI).condition}
                                    </span>
                                </Accordion.Header>
                                <Accordion.Body 
                                className="SideDrawer1-filter-body"
                                >
                                    <RadioBoxCondition
                                        infoSource={infoSource}
                                        useC={useC}
                                        setUseC={setUseC}
                                        newC={newC}
                                        setNewC={setNewC}
                                        handleFilters={filtersC =>
                                            handleFilters(filtersC, "condition")
                                        }
                                    />
                                </Accordion.Body>
                            </Accordion.Item>
                            
                            {/* Rating */}
                            <Accordion.Item eventKey="584" className="SideDrawer1-filter-item">
                                <Accordion.Header className="SideDrawer1-filter-header">
                                    <FaStar className="SideDrawer1-filter-header-icon" />
                                    <span className="SideDrawer1-filter-header-text">
                                        {infoSource.laguangeElakay('title', infoSource.languageAPI).rating}
                                    </span>
                                </Accordion.Header>
                                <Accordion.Body className="SideDrawer1-filter-body">
                                    <RadioboxRating
                                        infoSource={infoSource}
                                        allStars={allStars}
                                        handleFilters={filtersC =>
                                            handleFilters(filtersC, "Stars")
                                        }
                                    />
                                </Accordion.Body>
                            </Accordion.Item>
                        </>
                    )}
                </Accordion>
            </div>

            {/* Footer avec bouton clear */}
            {handleFilters && (
                <div className="SideDrawer1-filters-footer">
                    <button
                        className="SideDrawer1-clear-filters-btn"
                        onClick={() => clickButton()}
                    >
                        <MdRefresh className="SideDrawer1-clear-icon" />
                        <span>{infoSource.laguangeElakay('Button', infoSource.languageAPI).clearAll}</span>
                    </button>
                </div>
            )}
        </div>
    );

    return FilterProduct();
};

export default Filters;
